module.exports = __webpack_public_path__ + "static/media/49.8835222e.png";